/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileExclamation} from '@fortawesome/pro-duotone-svg-icons';

const IncidentManagementIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFileExclamation} {...props} />
);

export default IncidentManagementIcon;
